import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb';
import ReactQuill from 'react-quill';
import { Link } from 'react-router-dom';

export default function Compose() {

  var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],

    ['blockquote', 'code-block'],

    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],

    [{ 'align': [] }],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    ['link', 'image'],

    [{ 'script': 'sub' }, { 'script': 'super' }],
  ];

  return (
    <>
      <Breadcrumb title="Compose" path="Inbox / Compose" />
      <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
        <div className='flex flex-col gap-15 pb-15 mb-15 border-b border-border'>
          <div className='form-group'>
            <input type='text' id='emailTo' name='emailTo' placeholder='To' />
          </div>
          <div className='form-group'>
            <input type='text' id='emailCc' name='emailCc' placeholder='CC' />
          </div>
          <div className='form-group'>
            <input type='text' id='emailSubject' name='emailSubject' placeholder='Subject' />
          </div>
        </div>
        <div className='mb-30'>
          <ReactQuill
            modules={{ toolbar: toolbarOptions }}
            className='bg-bg-light'
            defaultValue="
            <p>
              Hello There !
            </p>
            <p>
              The toolbar can be customized and it also supports various callbacks such as 
              <span style='color: red;'>oninit</span>, 
              <span style='color: red;'>onfocus</span>, 
              <span style='color: red;'>onpaste</span> 
              and many more.
            </p>
            <br/>
            <p>
              Please try 
              <b>paste some texts</b>
              here
            </p>
            "
          />
        </div>
        <div className='flex flex-wrap gap-10'>
          <button className='btn btn-success'>
            Send Message
          </button>
          <button className='btn btn-secondary'>
            Draft
          </button>
          <Link to="/inbox" className='btn btn-outline-secondary'>
            Cancel
          </Link>
        </div>
      </div>
    </>
  )
}
